export default {
	Error: 'Error',
};
